// extracted by mini-css-extract-plugin
export var chip = "_88-1";
export var chipError = "_88-8";
export var errorBar = "_88-9";
export var errorIcon = "_88-a";
export var fileChip = "_88-3";
export var fileChipExt = "_88-5";
export var fileChipIcon = "_88-4";
export var removeButton = "_88-b";
export var removeIcon = "_88-c";
export var row = "_88-0";
export var spinnerBadge = "_88-7";
export var thumbnail = "_88-2";
export var thumbnailUploading = "_88-6";